import React, { useState } from 'react';
import { groupCover } from '../config/groupImages';

// Representative "picture" for a group, derived from its type (Cooking → kitchen theme, etc.).
// Shows the admin-set real photo (imageUrl) when present, otherwise a themed gradient + emoji.
export default function GroupCover({ group, height = 120, radius = 'var(--radius)', style = {} }) {
  const { emoji, gradient, imageUrl } = groupCover(group);
  const [imgOk, setImgOk] = useState(true);
  const showImg = imageUrl && imgOk;
  return (
    <div style={{
      height, width: '100%', borderRadius: radius, overflow: 'hidden',
      background: gradient, position: 'relative',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, ...style,
    }}>
      {showImg ? (
        <img src={imageUrl} alt={group?.name || 'group'} onError={() => setImgOk(false)}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
      ) : (
        <span style={{ fontSize: Math.round(height * 0.5), lineHeight: 1, filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.25))' }}>{emoji}</span>
      )}
    </div>
  );
}
